





























































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import {CargoEntity} from "@/entity/CargoEntity";

@Component({
    components: {
        Decimal,
        EnabledSwitch,
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class Cargo extends  Vue{
    items : CargoEntity[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "cargo";
    action:string = this.baseAction;
    data : CargoEntity = new CargoEntity();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "cargo_id"
        },
        {text: "İsim", value: "name"},
        {text: "Min sepet tutarı", value: "min_basket_price"},
        {text: "Kargo ücreti", value: "price"},
        {text: "Kapıda ödeme ücreti", value: "payment_price"},
        {text: "Aktif", value: "enabled"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:CargoEntity){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.cargo_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new CargoEntity();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
